
import React from 'react';
import { Link } from 'react-router-dom';
import { Building, Users, FolderOpen, FileText, Mail, HelpCircle, LogIn, Search } from 'lucide-react';

export const FooterCompanyLinks = () => {
  const companyLinks = [
    { name: 'About Us', href: '/about', icon: Building },
    { name: 'Careers', href: '/careers', icon: Users },
    { name: 'Portfolio', href: '/portfolio', icon: FolderOpen },
    { name: 'Blog', href: '/blog', icon: FileText },
    { name: 'Contact', href: '/contact', icon: Mail },
    { name: 'FAQs', href: '/faq', icon: HelpCircle },
    { name: 'Client Login', href: '/client-login', icon: LogIn },
    { name: 'Check My Site', href: '/checkmysite', icon: Search }
  ];

  return (
    <div>
      <h3 className="mb-4 text-base font-semibold text-white">Company</h3>
      <ul className="space-y-2">
        {companyLinks.map((link) => (
          <li key={link.name}>
            <Link 
              to={link.href}
              className="group flex min-h-0 items-center py-0.5 text-sm leading-5 text-gray-300 transition-colors hover:text-blue-400"
            >
              <link.icon className="h-4 w-4 mr-3 group-hover:text-blue-400 flex-shrink-0" />
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
      
      <div className="mt-5">
        <h4 className="mb-2 text-sm font-semibold text-white">Business Hours</h4>
        <div className="text-xs text-gray-300 space-y-1">
          <div>Mon-Fri: 9:00 AM - 6:00 PM GMT</div>
          <div>Support response times are agreed per service plan</div>
        </div>
      </div>
    </div>
  );
};
